import { AnimationActions } from '../../actions/animations/animations.actions';

export interface AnimationState {
  visible: boolean;
}

export const initialState: AnimationState = {
    visible: false
};

export function animationReducer(
  state: AnimationState = initialState,
  action: any
): AnimationState {
  switch (action.type) {
    case AnimationActions.SHOW_ANIMATION:
      return {
        visible: true
      };
    case AnimationActions.HIDE_ANIMATION:
      return {
        visible: false
      };
    default:
      return state;
  }
}
